// extracted by css-extract-rspack-plugin
export default {"tab":"tcJXS","list":"FYBuv","tabLabel":"YpmCN","panelContainer":"ei5k7","header":"eeTPU","panel":"YWxTX","dropZone":"gl5mB","isActive":"IocXK"};